import React, { useMemo, memo, forwardRef } from "react";
import PropTypes from "prop-types";
import hoistNonReactStatics from "hoist-non-react-statics";
import { themeable } from "./utils";

export default function withTheme(defaultTheme = {}) {
  return Component => {
    // eslint-disable-next-line
    Object.assign(Component.propTypes || {}, {
      theme: PropTypes.object.isRequired
    });
    // eslint-disable-next-line react/prop-types
    const ThemedComponent = ({ theme = {}, ...props }) => {
      const memoizedTheme = useMemo(() => themeable(defaultTheme, theme), [theme]);
      return <Component {...props} theme={memoizedTheme} />;
    };
    hoistNonReactStatics(ThemedComponent, Component);
    return memo(forwardRef((props, ref) => <ThemedComponent {...props} forwardRef={ref} />));
  };
}
